/**
 * Builds the copy for the archive confirmation dialog. When a course has
 * active enrollments, the dialog warns explicitly (archiving preserves all
 * data and enrollment history); otherwise it shows the plain archive notice.
 */
export interface ArchiveWarningCopy {
  title: string;
  items: string[];
}

export const buildArchiveWarning = (
  activeEnrollmentCount: number,
): ArchiveWarningCopy => {
  if (activeEnrollmentCount > 0) {
    return {
      title: "Warning: this course has active enrollments.",
      items: [
        `This course has ${activeEnrollmentCount} active enrollment(s).`,
        "Archiving hides the course from learners but preserves all data and enrollment history.",
      ],
    };
  }

  return {
    title: "This course will be archived.",
    items: ["Archiving hides the course from learners but preserves all data."],
  };
};
